import api from '../api'

export const postBrand = (params) => api.post('/admin/machines/makers', params)

export const putBrand = ({ id, ...params }) => api.put(`/admin/machines/makers/${ id }`, params)

export const deleteBrand = ({ id }) => api.delete(`/admin/machines/makers/${ id }`)
